import { render, staticRenderFns } from "./UpdateCarpark.vue?vue&type=template&id=f84e994a&"
import script from "./UpdateCarpark.vue?vue&type=script&lang=js&"
export * from "./UpdateCarpark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports